import { render } from "./BottomIntroduce.vue?vue&type=template&id=2332c2f2&scoped=true"
import script from "./BottomIntroduce.vue?vue&type=script&lang=js"
export * from "./BottomIntroduce.vue?vue&type=script&lang=js"

import "./BottomIntroduce.vue?vue&type=style&index=0&id=2332c2f2&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2332c2f2"]])

export default __exports__